<template>
  <div class="area">
    <div class="u-containar-md">
      <HeadingLv3 text="会員登録がまだの方はこちら" simple></HeadingLv3>
      <p class="leadText">
        イベント申し込みには会員登録が必要です。<br
          class="hiddenPc"
        />下記からイベント申し込みと会員登録が同時に行えます。
      </p>
      <Button
        :href="registerPath"
        label="イベント申し込み /会員登録"
        :handleClick="() => $router.push(registerPath)"
        secondary
        wide303
        class="btn"
      />
      <div class="toGuide">
        <a href="https://resident.mynavi.jp/guide">初めての方へ</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'ToRegisterEvent',
  components: {
    HeadingLv3,
    Button
  },
  setup() {
    const route = useRoute()
    const registerPath = computed(() => {
      const base = '/register/events/user_category'
      return `${base}?event_id=${route.params.id}`
    })

    return {
      registerPath
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.area {
  margin-top: -35px;
  background-color: #e5f7f6;
  padding: 32px 0 35px;
  @include mixins.media() {
    text-align: center;
    padding: 42px 0 50px;
  }
}
.leadText {
  margin-top: 16px;
  letter-spacing: 0.03em;
  @include mixins.media() {
    margin-top: 24px;
  }
}
.btn {
  margin-top: 22px;
  @include mixins.media() {
    margin-top: 27px;
  }
}
.toGuide {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  @include mixins.media() {
    margin-top: 22px;
  }

  a {
    display: flex;
    align-items: center;
    letter-spacing: 0.03em;
    color: var.$color-main-text;
    &::before {
      content: '';
      display: inline-block;
      width: 11px;
      height: 16px;
      background-image: url('~@/assets/icon/guide.svg');
      background-size: 11px 16px;
      margin-right: 10px;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 6px;
      height: 11px;
      background-image: url('~@/assets/icon/arrow-right-main.svg');
      background-size: 6px 11px;
      margin-left: 7px;
    }
  }
}
</style>
